export enum RouteKeys {
  List = '/reported-users',
  Details = '/reported-users/:id',
}
